<template>
  <div class="col-md-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-md-9 col-12 d-flex align-items-center">
          <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist">
            <li
              class="nav-item"
              v-for="(item, index) in tabOptions"
              :key="index"
            >
              <a
                class="nav-link"
                :class="{ active: currentView === item.value }"
                id="top-home-tab"
                data-bs-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="top-home"
                :aria-selected="currentView === item.value ? 'true' : 'false'"
                @click.prevent="changeView(item.value)"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>

        <div class="col-md-3 col-12 d-flex justify-content-end">
          <button class="btn btn-primary" @click="navigateToCreate">
            Crear Formulario
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="row">
        <div class="col-12 d-flex align-items-center">
          <div class="input-group me-3" style="max-width: 600px">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por formulario, descripción o usuario..."
              v-model="searchQuery"
              @input="onSearchChange"
            />
            <button
              v-if="searchQuery"
              class="btn btn-outline-secondary"
              type="button"
              @click="clearSearch"
              title="Limpiar búsqueda"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="dropdown d-flex justify-content-end">
            <button
              class="btn dropdown-toggle"
              style="width: 150px"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa fa-filter me-1"></i>
              {{ selectedFilter }}
            </button>
            <ul class="dropdown-menu">
              <li v-for="filter in filterOptions" :key="filter">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="onFilterChange(filter)"
                  :class="{ active: selectedFilter === filter }"
                >
                  {{ filter }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  currentView: {
    type: String,
    default: "mis-formularios",
  },
});

const emit = defineEmits([
  "formCreated",
  "viewChanged",
  "searchChanged",
  "filterChanged",
]);

const router = useRouter();
const searchQuery = ref("");
const selectedFilter = ref("Sin Filtro");

const tabOptions = [
  {
    name: "Mis Formularios",
    value: "mis-formularios",
  },
  {
    name: "Todos los Formularios",
    value: "todos-formularios",
  },
];

const filterOptions = [
  "Sin Filtro",
  "TODOS",
  "SER - PRIMARIA",
  "SER - SECUNDARIA",
  "SEA - ALTERNATIVA",
  "SEA - ESPECIAL",
  "MAESTRO - REGULAR",
  "MAESTRO - ALTERNATIVA",
  "MAESTRO - ESPECIAL",
  "MAESTRO - ESFM",
  "ESFM",
];

const navigateToCreate = () => {
  router.push({ name: "Crear Formulario" });
};

const changeView = (view) => {
  emit("viewChanged", view);
};

const onSearchChange = () => {
  emit("searchChanged", searchQuery.value);
};

const onFilterChange = (filter) => {
  selectedFilter.value = filter;
  emit("filterChanged", filter);
};

const clearSearch = () => {
  searchQuery.value = "";
  emit("searchChanged", "");
};

watch(
  () => props.currentView,
  (newView) => {
    searchQuery.value = "";
    selectedFilter.value = "Sin Filtro";
  }
);
</script>
